import { defineComponent as m, openBlock as o, createElementBlock as a, mergeProps as H, unref as e, renderSlot as Z, createElementVNode as n, createCommentVNode as V } from "vue";
import { useScalarIcon as p } from "../hooks/useScalarIcon.js";
const i = { key: 0 }, u = { key: 1 }, g = { key: 2 }, M = { key: 3 }, f = { key: 4 }, k = { key: 5 }, w = {
  name: "ScalarIconAppWindow"
}, _ = /* @__PURE__ */ m({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: A, weight: l } = p(s);
    return (d, t) => (o(), a("svg", H({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(A)), [
      Z(d.$slots, "default"),
      e(l) === "bold" ? (o(), a("g", i, t[0] || (t[0] = [
        n("path", { d: "M216,36H40A20,20,0,0,0,20,56V200a20,20,0,0,0,20,20H216a20,20,0,0,0,20-20V56A20,20,0,0,0,216,36Zm-4,160H44V60H212ZM60,92a16,16,0,1,1,16,16A16,16,0,0,1,60,92Zm48,0a16,16,0,1,1,16,16A16,16,0,0,1,108,92Z" }, null, -1)
      ]))) : e(l) === "duotone" ? (o(), a("g", u, t[1] || (t[1] = [
        n("path", {
          d: "M224,56V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216A8,8,0,0,1,224,56Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H40V56H216V200ZM80,84A12,12,0,1,1,68,72,12,12,0,0,1,80,84Zm40,0a12,12,0,1,1-12-12A12,12,0,0,1,120,84Z" }, null, -1)
      ]))) : e(l) === "fill" ? (o(), a("g", g, t[2] || (t[2] = [
        n("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM68,96A12,12,0,1,1,80,84,12,12,0,0,1,68,96Zm40,0a12,12,0,1,1,12-12A12,12,0,0,1,108,96Z" }, null, -1)
      ]))) : e(l) === "light" ? (o(), a("g", M, t[3] || (t[3] = [
        n("path", { d: "M216,42H40A14,14,0,0,0,26,56V200a14,14,0,0,0,14,14H216a14,14,0,0,0,14-14V56A14,14,0,0,0,216,42Zm2,158a2,2,0,0,1-2,2H40a2,2,0,0,1-2-2V56a2,2,0,0,1,2-2H216a2,2,0,0,1,2,2ZM78,84A10,10,0,1,1,68,74,10,10,0,0,1,78,84Zm40,0a10,10,0,1,1-10-10A10,10,0,0,1,118,84Z" }, null, -1)
      ]))) : e(l) === "regular" ? (o(), a("g", f, t[4] || (t[4] = [
        n("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H40V56H216V200ZM80,84A12,12,0,1,1,68,72,12,12,0,0,1,80,84Zm40,0a12,12,0,1,1-12-12A12,12,0,0,1,120,84Z" }, null, -1)
      ]))) : e(l) === "thin" ? (o(), a("g", k, t[5] || (t[5] = [
        n("path", { d: "M216,44H40A12,12,0,0,0,28,56V200a12,12,0,0,0,12,12H216a12,12,0,0,0,12-12V56A12,12,0,0,0,216,44Zm4,156a4,4,0,0,1-4,4H40a4,4,0,0,1-4-4V56a4,4,0,0,1,4-4H216a4,4,0,0,1,4,4ZM76,84a8,8,0,1,1-8-8A8,8,0,0,1,76,84Zm40,0a8,8,0,1,1-8-8A8,8,0,0,1,116,84Z" }, null, -1)
      ]))) : V("", !0)
    ], 16));
  }
});
export {
  _ as default
};
